<template>
  <a role="button" class="text-red-600 text-sm" @click="showRemoveRoleDialog">Remove</a>
</template>

<script>
export default {
  props: {
    role: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showRemoveRoleDialog() {
      this.$modal.show({
        component: () => import('./DeleteRoleDialog.vue'),
        props: {
          role: this.role,
        },
        on: {
          deleted: () => {
            this.$emit('deleted');
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
